import { useState } from "react";
import Image from "../elements/Image";
import { Link } from "react-router-dom";
import { classNames } from "src/helpers/classNames";
import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { Menu } from "@headlessui/react";

const CollapsibleGroup = ({ item, menu_id }) => {
  const [isOpen, setIsOpen] = useState(false);
  const isParentSelected = item._id === menu_id || item.submenu?.some((subItem) => subItem._id === menu_id || subItem.slug === menu_id);

  return (
    <div>
      <button
        type="button"
        className={classNames("flex w-full items-center justify-between gap-3 rounded px-3 py-2.5 text-gray-700 transition-all duration-200 hover:bg-gray-100 hover:text-leftNavActiveTextColor", isParentSelected ? "bg-gray-100 text-leftNavActiveTextColor" : "")}
        onClick={() => setIsOpen(!isOpen)}>
        <div className="flex items-center gap-3">
          {(item.icon || item?.image) && (
            <div className="flex h-5 w-5 items-center justify-center text-base">
              {item.icon ? (
                <item.icon className="stroke-1.5 h-4 w-4" />
              ) : (
                <Image
                  src={item?.image}
                  alt={item?.name || ""}
                  width={"100%"}
                  height={"100%"}
                  effect={"blur"}
                  classes={"object-cover"}
                />
              )}
            </div>
          )}
          <div className="max-w-[200px] overflow-hidden truncate whitespace-nowrap text-sm">{item.label}</div>
        </div>
        <div className={classNames("transition-transform duration-200", isOpen ? "rotate-90" : "")}>
          <ChevronRightIcon className="h-4 w-4" />
        </div>
      </button>

      {isOpen && (
        <div className="ml-2 mt-1 space-y-1 border-l-2 border-gray-200 pl-2">
          {item.submenu?.map((subItem) => (
            <Menu.Item key={subItem._id}>
              <Link
                to={subItem.link}
                className={classNames("flex w-full items-center gap-3 rounded px-3 py-2.5 transition-all duration-200", subItem._id === menu_id || subItem.slug === menu_id ? "bg-gray-100 text-leftNavActiveTextColor" : "hover:bg-gray-100 hover:text-leftNavActiveTextColor")}>
                {(subItem.icon || subItem?.image) && (
                  <div className="flex h-5 w-5 items-center justify-center text-base">
                    {subItem.icon ? (
                      <subItem.icon className="stroke-1.5 h-4 w-4" />
                    ) : (
                      <Image
                        src={subItem?.image}
                        alt={subItem?.name || ""}
                        width={"100%"}
                        height={"100%"}
                        effect={"blur"}
                        classes={"object-cover"}
                      />
                    )}
                  </div>
                )}
                <div className="max-w-[200px] overflow-hidden truncate whitespace-nowrap text-sm">{subItem.label}</div>
              </Link>
            </Menu.Item>
          ))}
        </div>
      )}
    </div>
  );
};

export default CollapsibleGroup;
